import { Box } from "@chakra-ui/react";
import { Section, type SectionProps } from "components/section";
import React from "react";
import { Button } from "ui/button";
import { TextTitle } from "ui/text";

type SizzleReelProps = {
  /**
   * @default true
   */
  autoplay?: HTMLVideoElement["autoplay"];
} & SectionProps;

export function AiDecisioningSizzleReel({ autoplay = true, ...sectionProps }: SizzleReelProps) {
  return (
    <Section my={0} {...sectionProps}>
      <TextTitle
        align="center"
        size="lg"
        descriptionMaxW="600px"
        title="Take your marketing beyond human scale with AI Decisioning"
        description="Uncover the most effective way to engage each customer with automated experimentation and machine learning"
        actions={
          <Button hasRightChevron href="/platform/ai-decisioning">
            Learn more
          </Button>
        }
      />

      <Box
        border="1px"
        borderColor="new.violet.150"
        borderRadius="small"
        pos="relative"
        maxW={{ base: "2xl", md: "5xl" }}
        mx="auto"
        mt={{ base: "bigger", md: "biggest" }}
        overflow="hidden"
      >
        <video
          controls
          loop
          muted
          playsInline
          autoPlay={autoplay}
          width="100%"
          preload="metadata"
          controlsList="nodownload"
        >
          <source
            src="https://cdn.sanity.io/files/pwmfmi47/production/6587b8309c46b896120f05fb9a8508795f0fddd0.mp4"
            type="video/mp4"
          />
        </video>
      </Box>
    </Section>
  );
}
